module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/suitcase-3d32c4ff2da4bc0e6978bda98c3a7c69.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/suitcase.svg
// module id = pjKS
// module chunks = 24